var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgData01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-001",
    id: "Shape_Copy_3",
    "data-name": "Shape Copy 3",
    d: "M13,10H11V8h2v2ZM9,10H7V8H9v2ZM5,10H0V8H5v2Zm8-4H11V4h2V6ZM9,6H7V4H9V6ZM5,6H0V4H5V6Zm8-4H11V0h2V2ZM9,2H7V0H9V2ZM5,2H0V0H5V2Z",
    fill: "#b5c5d2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData01);
export default __webpack_public_path__ + "static/media/data-01.a29c466eeefae6bae1299dd00ce40562.svg";
export { ForwardRef as ReactComponent };